import Compressor from 'compressorjs';

export function createQueryString(params) {
	return Object.keys(params)
		.map(k => {
			if (Array.isArray(params[k])) return params[k].map(x => encodeURIComponent(k) + '=' + encodeURIComponent(x)).join('&');
			return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
		})
		.join('&');
}

export function createUri(base, endPoint, { params = null, query = null } = {}) {
	if (params && typeof params === 'object') {
		for (let key in params) {
			endPoint = endPoint.replace(`:${key}`, params[key]);
		}
	}

	let url = `${base}/${endPoint}`;

	if (query && typeof query === 'object') {
		url += '?' + createQueryString(query);
	}

	return url;
}

export function createMap(value = [], idField = 'id') {
	if (!Array.isArray(value) || value.length === 0) return new Map();

	return value.reduce((map, v) => {
		if (typeof v !== 'object') return map;

		if (!map.has(value[idField])) {
			return map.set(value[idField], v);
		}
	}, new Map());
}

export function compressImage(file) {
	return new Promise((resolve, reject) => {
		new Compressor(file, {
			quality: 0.3,
			success(result) {
				resolve(result);
			},
			error(err) {
				reject(err);
			},
		});
	});
}

export function encodeImageBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader(file);

		reader.onloadend = () => {
			resolve(reader.result);
		};

		reader.onerror = reject;

		reader.readAsDataURL(file);
	});
}

export function getEnumValue(obj, name, invalid = '') {
	const v = Object.values(obj).find(x => x.name.toLowerCase() === name.toLowerCase());
	return v ? v.value : invalid;
}

export function getEnumName(obj, value, invalid = '') {
	const v = Object.values(obj).find(x => x.value === value);
	return v ? v.name : invalid;
}

export function getEnumProperty(obj, value, property = 'value', invalid = '') {
	const v = Object.values(obj).find(x => x.value === value);
	return v ? v[property] : invalid;
}
